<template>
  <div class="">
    <el-dialog
      ref="form" v-model="show" :close-on-click-modal="false" title="重置密码" :show-close="false"
      :close-on-press-escape="false"
      @close="handleCancel">
      <el-form v-if="confirmPassword===false" :model="form" label-width="100px">
        <el-form-item prop="name" label="用户" required>
          <span class="user-inline">
            <el-icon :size="16"><User /></el-icon>
            {{ form.username }}
          </span>
        </el-form-item>
        <el-form-item prop="password" label="新密码" :rules="[{required:true,message:'请生成密码'}]">
          <div class="generate-password">
            <el-input v-model="form.password" placeholder="请生成密码" readonly />
            <el-button type="primary" link @click="form.password=$func.generatePassword()">
              生成密码
              <el-icon>
                <Refresh />
              </el-icon>
            </el-button>
          </div>
          <div class="tips">重置密码不允许输入，只能由系统生成，请点击生成密码</div>
        </el-form-item>
        <el-form-item>
          <el-button style="margin-right:10px;" @click="handleCancel">取 消</el-button>
          <el-button type="primary" @click="handleBeforeOk">确 定</el-button>
        </el-form-item>
      </el-form>
      <div v-else>
        <p style="font-size: 16px; text-align: center">
          新密码：
          <span ref="passwordText" style="font-weight: bold;">{{ form.password }}</span>
        </p>
        <p style="text-align: center; padding: 24px">
          <el-button type="primary" @click="copyAndClose">复制并关闭</el-button>
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { putRestsPwd } from "@/api/sso/agent";
import { putClientRestsPwd } from "@/api/sso/agent/clients";
import { putStaffsRestsPwd } from "@/api/sso/agent/staffs";
import { Refresh, User } from "@element-plus/icons-vue";


export default {
  components: { Refresh, User },
  data() {
    return {
      show: false,
      form: { password: "" },
      type: "",
      visible: false,
      confirmPassword: false
    };
  },
  methods: {
    handleOpen(val, type) {
      this.type = type;
      this.form = val;
      this.form.password = "";
      this.show = true;
      this.confirmPassword = false;
    },
    handleCancel() {
      this.show = false;
    },
    handleBeforeOk() {
      if (this.type === "agent") {
        putRestsPwd(this.form).then(() => {
          this.confirmPassword = true;
        });
      } else if (this.type === "client") {
        putClientRestsPwd(this.form).then(() => {
          this.confirmPassword = true;
        });
      } else {
        putStaffsRestsPwd(this.form).then(() => {
          this.show = false;
          this.visible = true;
        });
      }
    },
    copyPassword() {
      const textarea = document.createElement("textarea");
      textarea.value = this.form.password;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);

      this.$message.success("密码复制成功");
    },
    copyAndClose() {
      this.copyPassword();
      this.show = false;
      this.$emit("refresh");
    }
  }
};
</script>

<style scoped>
.tips {
  margin-top: 4px;
  color: #e45851;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
}
</style>
